<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
export default {
  mixins: [apibtoast, apigeneric],
  props: ["satdosyaId", "Tamamlandi"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
  },
  watch: {
    satdosyaId() {
      this.Get();
     },
  },
  methods: {
    onSubmit() {
      this.Update("satdosya", this.FormData).then((res) => {
        if (res) {
          this.$bvModal.hide("yaklasikmaliyetgorevlileri");
          this.$emit("TableUpdate"); 
        }
      });
    },
    Get() {
      this.ActionsSingleGet({
        Service: "satdosya",
        Id: this.satdosyaId,
      }).then((res) => {
        this.FormData = res.Data;
        if (!this.FormData.Yaklasikmaliyetgorevliler) {
          this.FormData.Yaklasikmaliyetgorevliler = [];
        }

      });
    },
    AddGorevli() {
      this.FormData.Yaklasikmaliyetgorevliler.push({ AdSoyad: "", Unvan: "" });
    },
    DelGorevli(index) {
      this.FormData.Yaklasikmaliyetgorevliler.splice(index, 1);
    },
  },
};
</script>
<template>
  <Loader>
    <b-modal id="yaklasikmaliyetgorevlileri" size="xl" :title="$t('yaklasikmaliyetgorevlileri.Title')"
      title-class="font-18" hide-footer>
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <Form @submit.prevent="onSubmit">
                <div class="inner-repeater mb-4">
                  <div class="inner mb-3">
                    <div v-for="(data, index) in FormData.Yaklasikmaliyetgorevliler" :key="data.id"
                      class="inner mb-3 row">
                      <div class="col-md-5 col-4">
                        <label>{{ $t("yaklasikmaliyetgorevlileri.AddEdit.AdSoyad") }}</label>
                        <input v-model="data.AdSoyad" :disabled="Tamamlandi" type="text" class="inner form-control" />
                      </div>
                      <div class="col-md-5 col-4">
                        <label>{{ $t("yaklasikmaliyetgorevlileri.AddEdit.Unvan") }}</label>
                        <input v-model="data.Unvan" :disabled="Tamamlandi" type="text" class="inner form-control" />
                      </div>
                      <div class="col-md-1 col-4">
                        <label>&nbsp;</label>
                        <div class="d-grid">
                          <input type="button" v-if="!Tamamlandi" class="btn btn-primary btn-block"
                            :value="$t('yaklasikmaliyetgorevlileri.AddEdit.Sil')" @click="DelGorevli(index)" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="d-flex align-content-center justify-content-between">
                    <button v-if="!Tamamlandi" class="btn btn-primary"
                      type="submit">
                      {{ $t("yaklasikmaliyetgorevlileri.AddEdit.Button") }}
                    </button>
                    <button @click="AddGorevli" v-if="!Tamamlandi" class="btn btn-success" type="button">
                      {{ $t("yaklasikmaliyetgorevlileri.AddEdit.Ekle") }}
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
</Loader></template>
